import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import _ from 'lodash';

import { getProfile, isLoadingProfileSelector, profileSelector } from 'src/store/profile';

import { PageLoader } from 'src/components';
import { ROUTE } from 'src/constants';

export const ProtectedRoute = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const profileData = useSelector(profileSelector);
  const isLoading = useSelector(isLoadingProfileSelector);

  const savedProfile = localStorage.getItem('profile');

  useEffect(() => {
    if (_.isEmpty(profileData)) {
      dispatch(getProfile({ navigate }));
    }
  }, [dispatch, navigate, profileData]);

  return isLoading ? <PageLoader /> : savedProfile ? <Outlet /> : <Navigate to={ROUTE.HOME} />;
};
